import React from "react";
import Show from "../../../utils/show.component";
import { AuthPaymentContainer } from "../misc/auth-payment-container.component";
import { AuthRestartButton } from "../misc/restart-button.component";
import { ReviewDisplayField } from "../misc/review-display-field.component";
import getPaymentDay from "../misc/get-payment-day";
import { formatLastFour, generateLoanDescription } from "../misc/messaging-utils";

export const AuthPaymentRecurringOpenEndSummary = (props) => {
  const subtitle = `Your payment has been successfully submitted. A confirmation email has been sent to email
  address: ${props.confirmationEmail}`;

  return (
    <AuthPaymentContainer title="Payment Summary" subtitle={subtitle}>
      <div className="bold f20 text-centered">
        {`${generateLoanDescription(props.selectedLoan, true)}`}
      </div>
      <div className="my-4 divider"></div>
      <div>
        <Show condition={props.openEndPaymentType !== "Fixed Amount"}>
          <ReviewDisplayField
            title={"Payment Method"}
            value={props.openEndPaymentType}
            valueClassNames={"minwidth-fit"}
            titleColumnSize={"col-md-5"}
            valueColumnSize={"col-md-7"}
          />
        </Show>
        <ReviewDisplayField title={"First Payment Date"} value={props.firstPaymentDate} />
        <ReviewDisplayField title={"Payment Frequency"} value={props.paymentFrequency} />
        <ReviewDisplayField
          title={"Payment Day"}
          value={getPaymentDay(props.paymentFrequency, props.firstPaymentDate)}
        />
        <ReviewDisplayField
          title={"Payment Account"}
          value={`Ending in ${props.paymentAccount}`}
          valueClassNames={"minwidth-fit"}
        />
        <Show condition={props.openEndPaymentType === "Fixed Amount"}>
          <ReviewDisplayField title={"Payment Amount"} value={props.paymentAmount} />
        </Show>
      </div>
      <AuthRestartButton backToLoans={props.backToLoans} bgColor={"#00558c"} />
    </AuthPaymentContainer>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/summary/auth-payment-recurring-open-end-summary.component.js